export enum KickoffNameEnum {
  KICK_OFF = "KICK_OFF"
}

export const KickoffNameEnumValues: {
  [key in KickoffNameEnum]: string;
} = {
  [KickoffNameEnum.KICK_OFF]: "Kick-Off"
};